import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { isAuthRequired } from "@/lib/reportSender";

export const ReportsAuthBanner = () => {
  const [on, setOn] = useState(isAuthRequired());
  const navigate = useNavigate();
  useEffect(() => {
    const f = () => setOn(isAuthRequired());
    window.addEventListener("reports-auth-changed", f); window.addEventListener("storage", f);
    return () => { window.removeEventListener("reports-auth-changed", f); window.removeEventListener("storage", f); };
  }, []);
  if (!on) return null;
  return (
    <div className="mx-4 mt-3 rounded-lg border border-[#FFB020]/40 bg-[#FFB020]/10 px-4 py-3 flex flex-wrap items-center gap-3 text-sm text-[#FFB020]" data-testid="reports-auth-banner">
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span className="flex-1">Reconnectez-vous pour envoyer vos comptes rendus en attente. Ils sont conservés sur l'appareil.</span>
      <button onClick={() => navigate("/login")} data-testid="reports-auth-relogin" className="rounded-md bg-[#FFB020] text-black px-3 py-1.5 font-medium">Se reconnecter</button>
    </div>
  );
};
